import React from "react";
import { FilterBar, FilterInput } from "../../FilterBar";
import { ClassOptionsDropdown } from "../../Classes/ClassOptionsDropdown";
import { BranchOptionsDropdown } from "../../Branches/BranchOptionDropdown";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";

interface IProps {
  isStudentsListLoading: boolean;
  studetListNameSpace: string;
}

export const StudentListFilter = ({
  isStudentsListLoading,
  studetListNameSpace,
}: IProps) => {
  const { filters, setFilter, applyFilters, clearFilters, hasActiveFilters } =
    useStudentListFilters(studetListNameSpace);

  const onClassSelect = (option: any) => {
    setFilter("classId", option.value);
  };

  const onBranchSelect = (option: any) => {
    setFilter("branchId", option.value);
  };

  const handleClear = () => {
    clearFilters();
  };

  const handleSearch = () => {
    applyFilters();
  };

  return (
    <FilterBar
      onSearch={handleSearch}
      onClear={handleClear}
      isLoading={isStudentsListLoading}
      showClearButton={hasActiveFilters()}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8">
        <FilterInput
          label="Student Name"
          placeholder="Search by student name..."
          value={filters.studentName}
          onChange={(value) => setFilter("studentName", value as string)}
        />
        <ClassOptionsDropdown
          onClassSelect={onClassSelect}
          selectedClassId={filters.classId}
        />
        <BranchOptionsDropdown
          onBranchSelect={onBranchSelect}
          selectedBranchId={filters.branchId}
        />
      </div>
    </FilterBar>
  );
};
